// Яндекс.Метрика — подключается только если в .env задан номер счётчика:
//   REACT_APP_YM_ID=12345678
// Если переменной нет (например, на локальной машине) — скрипт не грузится.

const YM_ID = process.env.REACT_APP_YM_ID;

export const initAnalytics = () => {
  if (!YM_ID || typeof window === "undefined") return;
  if (window.ym) return; // уже подключено

  /* eslint-disable */
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    (k = e.createElement(t)), (a = e.getElementsByTagName(t)[0]);
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  /* eslint-enable */

  window.ym(YM_ID, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
};

// ЦЕЛЬ «НАПИСАЛИ В WHATSAPP».
// Заявки больше не собираются формой, поэтому единственный видимый результат
// работы сайта — уход в мессенджер. Без этой отметки в Метрике не останется
// ни одной конверсии: цель с идентификатором `whatsapp` нужно один раз
// завести в интерфейсе счётчика.
export const trackGoal = (goal, params) => {
  if (!YM_ID || !window.ym) return;
  window.ym(YM_ID, "reachGoal", goal, params);
};

// Переход на другую страницу в SPA — Метрика сама такое не видит.
export const trackPageView = (url) => {
  if (!YM_ID || !window.ym) return;
  window.ym(YM_ID, "hit", url);
};

export default initAnalytics;
